import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const goHomeTop = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      // Ensure scroll happens after navigation
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 0);
    }
  };

  return (
    <footer className="section-dark border-t border-neutral-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <a
            href="/"
            onClick={goHomeTop}
            className="inline-block mb-5 mx-auto md:mx-0 opacity-80 hover:opacity-100 transition-all duration-300 hover:drop-shadow-[0_0_14px_rgba(225,6,0,0.55)]"
            aria-label="Ir al inicio"
            data-testid="footer-logo-link"
          >
            <img
              src="https://res.cloudinary.com/ot3yqjzj/image/upload/v1783599313/logo_cdkk3s.webp"
              alt="pillauncoche"
              className="h-12 w-auto object-contain block mx-auto md:mx-0"
              data-testid="footer-logo-img"
            />
          </a>
          <p className="text-neutral-400 text-sm leading-relaxed text-center md:text-left">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <h4 className="font-display text-lg mb-4 text-white">{t("footer.contacto")}</h4>
          <div className="space-y-2 text-neutral-300 text-sm">
            <a href="mailto:info@pillauncoche.com" className="flex items-center gap-2 link-hover-red" data-testid="footer-email">
              <Mail size={16} /> info@pillauncoche.com
            </a>
            <a href="tel:+34613807514" className="flex items-center gap-2 link-hover-red" data-testid="footer-phone">
              <Phone size={16} /> +34 613 80 75 14
            </a>
          </div>
        </div>
        <div>
          <h4 className="font-display text-lg mb-4 text-white">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-neutral-300 text-sm">
            <li><Link to="/legal/privacidad" className="link-hover-red" data-testid="footer-privacy">{t("footer.privacidad")}</Link></li>
            <li><Link to="/legal/terminos" className="link-hover-red" data-testid="footer-terms">{t("footer.terminos")}</Link></li>
            <li><Link to="/legal/cookies" className="link-hover-red" data-testid="footer-cookies">{t("footer.cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-900 text-center py-4 text-xs text-neutral-500">
        © {new Date().getFullYear()} pillauncoche · {t("footer.derechos")}
      </div>
    </footer>
  );
}
